var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClean = function SvgClean(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "8.5 9 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.559 16.1532L17.1826 13.9661L21.1664 11.6121C21.8109 11.2198 22.6623 11.4243 23.0546 12.0688C23.4469 12.7133 23.2424 13.5647 22.5979 13.957L18.559 16.1532Z",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4491 16.3732L17.1277 14.2065C16.3569 12.9449 14.8051 12.5632 13.5707 13.1761L10.7041 14.5879C9.77829 15.0424 9.45756 16.1411 10.0012 17.0187L12.6922 21.4274C13.229 22.3119 14.3481 22.5228 15.1776 21.9106L17.7413 20.0052C18.8519 19.1797 19.2199 17.6348 18.4491 16.3732Z",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2018 18.0908L11.3437 19.2264",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1281 16.3356L10.2699 17.4712",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2756 19.8462L12.4174 20.9818",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgClean;